/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Teams_Filter_MembersInputs */

const cs_settings_teams_filter_members = /** @type {(inputs: Settings_Teams_Filter_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrovat členy…`)
};

const en_settings_teams_filter_members = /** @type {(inputs: Settings_Teams_Filter_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter members…`)
};

/**
* | output |
* | --- |
* | "Filter members…" |
*
* @param {Settings_Teams_Filter_MembersInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_teams_filter_members = /** @type {((inputs?: Settings_Teams_Filter_MembersInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Teams_Filter_MembersInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_teams_filter_members(inputs)
	return cs_settings_teams_filter_members(inputs)
});